export default __webpack_public_path__ + "static/media/tutorial_preview_cr3.31f7b11f.png";